import { render, staticRenderFns } from "./QueriesView.vue?vue&type=template&id=1c41ceec&scoped=true"
import script from "./QueriesView.vue?vue&type=script&lang=js"
export * from "./QueriesView.vue?vue&type=script&lang=js"
import style0 from "./QueriesView.vue?vue&type=style&index=0&id=1c41ceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41ceec",
  null
  
)

export default component.exports